import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/img/CL/logo-primus-capital.svg';


const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);  // Estado del menú
  const navigate = useNavigate();
  const location = useLocation();

  const handleDropdownToggleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();  // Prevenir propagación del evento
    setIsDropdownOpen(!isDropdownOpen);  // Alterna el estado del dropdown
  };

  const handleMenuClick = (event) => {
    event.preventDefault();
    setIsNavCollapsed(true);  // Cierra el menú al hacer clic en un enlace
    setIsDropdownOpen(false);  // Cierra el dropdown si está abierto
    navigate('/productosyservicios');
  };

  const handleDropdownItemClick = (path) => {
    setIsDropdownOpen(false);
    setIsNavCollapsed(true);
    navigate(path);
  };

  const handleNavLinkClick = () => {
    setIsDropdownOpen(false);
    setIsNavCollapsed(true);
  };

  const handleNavCollapse = () => {
    setIsNavCollapsed((prevState) => !prevState);  // Alterna el estado del menú
    if (!isNavCollapsed) {  // Si el menú está abierto, lo cerramos
      setIsDropdownOpen(false);  // Cierra el dropdown si está abierto
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white">
      <NavLink className="navbar-brand" to="/" onClick={handleNavLinkClick}>
        <img src={logo} alt="Logo" height="50" />
      </NavLink>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded={!isNavCollapsed ? true : false}  // Controla la expansión del menú       
        aria-label="Toggle navigation"
        onClick={handleNavCollapse}
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
        <ul className="navbar-nav mr-auto">
          <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
            <NavLink className="nav-link" to="/" onClick={handleNavLinkClick}>Home</NavLink>
          </li>
          <li className={`nav-item ${location.pathname === '/nosotros' ? 'active' : ''}`}>
            <NavLink className="nav-link" to="/nosotros" onClick={handleNavLinkClick}>Nosotros</NavLink>
          </li>          
          <li className={`nav-item dropdown ${location.pathname === '/productosyservicios' ? 'active' : ''}`}>
            <div className="d-flex align-items-center">
              <NavLink
                className={`nav-link ${location.pathname === '/productosyservicios' ? 'active' : ''}`}
               
                id="navbarDropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded={isDropdownOpen ? 'true' : 'false'}
                onClick={handleMenuClick}
              >
                Productos y Servicios
              </NavLink>
              <span
                className="dropdown-toggle-icon ml-2"
                style={{ fontSize: '0.6em', cursor: 'pointer' }}
                onClick={handleDropdownToggleClick}
              >
                {isDropdownOpen ? '▲' : '▼'}
              </span>
            </div>
            <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
              <NavLink className="dropdown-item" to="/factoring" onClick={() => handleDropdownItemClick('/factoring')}>Factoring</NavLink>
              <NavLink className="dropdown-item" to="/factoringinternacional" onClick={() => handleDropdownItemClick('/factoringinternacional')}>Factoring Internacional</NavLink>
              
            </div>
          </li>
          <li className={`nav-item ${location.pathname === '/informaciondeinteres' ? 'active' : ''}`}>
            <NavLink className="nav-link" to="/informaciondeinteres" onClick={handleNavLinkClick}>Información de Interés</NavLink>
          </li>
          <li className={`nav-item ${location.pathname === '/contactanos' ? 'active' : ''}`}>
            <NavLink className="nav-link" to="/contactanos" onClick={handleNavLinkClick}>Contáctanos</NavLink>
          </li>
        </ul>
        <a className="btn btn-primary ml-auto buttonSucursal" href="https://corp.primuscapitalsf.com/SucursalVirtual">
  <i className="fas fa-user iconoButton"></i> <strong>Sucursal Virtual</strong>
</a>

      </div>
    </nav>
  );
}

export default Navbar;
